import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cf57e9a")

_pushScopeId("data-v-7cf57e9a")
const _hoisted_1 = { class: "admin-menu" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "title" }, [
  /*#__PURE__*/_createVNode("span", null, "マンガ"),
  /*#__PURE__*/_createVNode("span", null, "フィールド"),
  /*#__PURE__*/_createVNode("span", null, "管理者画面")
], -1)
const _hoisted_3 = { class: "commands" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "契約管理", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "メンテナンス", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "管理者情報", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "ログアウト", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toContract && _ctx.toContract(...args)))
      }, [
        _hoisted_4
      ]),
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toMaintenance && _ctx.toMaintenance(...args)))
      }, [
        _hoisted_5
      ]),
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toUsers && _ctx.toUsers(...args)))
      }, [
        _hoisted_6
      ]),
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, [
        _hoisted_7
      ])
    ])
  ]))
})